import styled from 'styled-components';

const StyledMultiFormError = styled.span`
    font-size: 0.72rem;
    font-weight: 600;
    color: #c0697a;
    text-shadow:
        1px 1px 1px var(--neu-shadow-light),
        -1px -1px 1px #9a4a5790;
    letter-spacing: 0.02em;
`;

export default StyledMultiFormError;
